import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

/*
 * DDT-4126: the Facturation section of the open conversation (messages/parts/_billing.html.twig).
 * "Honoraires envisagés" is edited in place; an "Honoraires facturés" pen opens the invoiced-fee
 * pop-up. Every save ends in a `case-billing:saved` window event carrying the server's response,
 * which messages.js uses to re-render this section, the conversation header and the list row.
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        expectedFeeUrl: String,
        invoicedFeeUrl: String,
        chatId: Number,
    }

    static targets = ['expectedFeeView', 'expectedFeeForm', 'expectedFeeInput']

    editExpectedFee() {
        this.expectedFeeViewTarget.classList.add('d-none')
        this.expectedFeeFormTarget.classList.remove('d-none')
        this.expectedFeeInputTarget.focus()
        this.expectedFeeInputTarget.select()
    }

    cancelExpectedFee() {
        this.expectedFeeInputTarget.value = this.expectedFeeInputTarget.defaultValue
        this.expectedFeeFormTarget.classList.add('d-none')
        this.expectedFeeViewTarget.classList.remove('d-none')
    }

    keepDigits(event) {
        event.target.value = event.target.value.replace(/\D/g, '')
    }

    saveExpectedFee(event) {
        event.preventDefault()

        $.ajax({
            url: this.expectedFeeUrlValue,
            method: 'POST',
            data: { amount: this.expectedFeeInputTarget.value },
            success: result => {
                window.dispatchEvent(new CustomEvent('case-billing:saved', {
                    detail: { chatId: this.chatIdValue, result },
                }))
            },
            error: xhr => {
                addAlert('danger', (xhr.responseJSON && xhr.responseJSON.message) || translations['profile.An unknown error occurred.'])
            },
        })
    }

    editInvoicedFee({ params }) {
        window.dispatchEvent(new CustomEvent('invoiced-fee:open', {
            detail: {
                url: this.invoicedFeeUrlValue,
                chatId: this.chatIdValue,
                invoicedFeeId: params.id || null,
                amount: params.amount,
                missionTypes: params.missionTypes || [],
            },
        }))
    }
}
